import { useState } from "react";
import { toast } from "react-hot-toast";
import rosterApi from "../../../api/roster/RosterApi";
import ConfirmModal from "../../../components/Common/ConfirmModal";

const ResetStaffNormalHours = ({
  staffId,
  staffName,
  onSuccess, // callback to reload overrides
}) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirmReset = async () => {
    if (loading) return;

    try {
      setLoading(true);

      const { response } = await rosterApi.resetStafftoNormalHours(staffId);

      toast.success(
        response?.data?.message ||
          "Staff reset to normal working hours successfully"
      );

      onSuccess?.();
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Failed to reset staff to normal working hours"
      );
    } finally {
      setLoading(false);
      setOpenConfirm(false);
    }
  };

  return (
    <>
      {/* Trigger */}
      <div className="relative inline-block group">
        <div
          className="text-xs text-yellowlight cursor-pointer hover:text-yellowlightLight transition"
          // onClick={() => setOpenConfirm(true)}
          onClick={(e) => {
            e.stopPropagation();
            setOpenConfirm(true);
          }}
        >
          Set normal hours
        </div>

        {/* Tooltip */}
        <div
          className="
          absolute -bottom-8 left-1/2 -translate-x-1/4 mb-2
          hidden group-hover:block
          whitespace-nowrap
          bg-black text-white text-[10px]
          px-2 py-1 rounded-md
          shadow-lg z-50
        "
        >
          Reset staff schedule to default hours
        </div>
      </div>
      {/* Confirm Modal */}
      <ConfirmModal
        open={openConfirm}
        title="Reset staff to normal hours"
        description={`This will remove all schedule overrides for ${
          staffName || "this staff"
        } and restore normal working hours.`}
        icon="⚠️"
        confirmText={loading ? "Resetting..." : "Reset"}
        onCancel={() => setOpenConfirm(false)}
        onConfirm={handleConfirmReset}
      />
    </>
  );
};

export default ResetStaffNormalHours;
